import { Injectable } from '@angular/core';
import { AsdBase } from 'src/app/model/asd/asd';
import { Attribute, MaskAttributes } from 'src/app/model/asd/asd-properties/asd-attribute';
import { HeaderItem } from 'src/app/model/asd/asd-properties/asd-ie-type/asd-list';
import { IEDisplayProperties, IELabel, InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { FormInit } from 'src/app/model/form/form-properties/form-init';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';

import { CosyFormGroupValidationService } from '../validator/cosy-form-group-validation.service';
import cloneDeep from 'lodash-es/cloneDeep';
import { ConsoleLogger } from '@angular/compiler-cli/private/localize';

@Injectable({
  providedIn: 'root'
})
export class CosyDynaeditorControllerService {

  public toProcessIEList : any[]= [];
  public processedCASD : AsdBase = new AsdBase();
  public previousProcessedCASD: AsdBase = new AsdBase();
  public mediatorCASD: AsdBase;
  private oldIESpecsList: 
    { id:any, 
      type: string; 
      name: any; 
      values: any[]; 
      order: any; 
      visible: any; 
      active: any; 
      sort: any, 
      status: any, 
      maskPattern: any, 
      maskValue: any, 
      displayFormat: any,
      width: any,
      height: any,
      alignment: any }[] = [];
  private oldIESpecs : {id:any, type: string; name: any; values: any[]; order: any; visible: any; active: any; sort: any, status: any, maskPattern: any, maskValue: any, displayFormat: any, width: any,height: any, alignment: any} = {
    id: null,
    type: null,
    name : null,
    values: [],
    order: null,
    visible: null,
    active: null,
    sort: null, status: null,
    maskPattern: null, 
    maskValue: null, 
    displayFormat: null,
    width: null,
    height: null,
    alignment: null
  };
  constructor(
    private cosyFormGroupValidationService: CosyFormGroupValidationService
  ) {}


  saveDynaEditorResults(actionType, dynaForm, formInitProps: FormInit, ie: InterfaceElement, dynaItem: any) {
  
    this.processedCASD = formInitProps.CustomAppStateDocument; 
    if (ie.TypeDID == InterfaceElementTypes.EntityList) this.saveEntityListDEResults(dynaForm,dynaItem,actionType, ie);
    if (ie.TypeDID == InterfaceElementTypes.FormEntity) this.saveEntityViewDEResults(dynaForm,dynaItem,actionType, ie);
    if (ie.TypeDID == InterfaceElementTypes.UXController|| ie.TypeDID == InterfaceElementTypes.ListUXController) this.saveUXControllerDEResults(dynaForm,dynaItem,actionType, ie);
    if (ie.TypeDID == InterfaceElementTypes.Wizard) this.saveWizardDEResults(dynaForm,dynaItem,actionType, ie);
  }

  dynaEditorProcessing(args, activity: string, ie: InterfaceElement, formInitProps: FormInit) {
   
    
    let casd: AsdBase = formInitProps.CustomAppStateDocument;
    if (args.name == 'entity-items') {
      if (activity == 'drag') {
        if(ie.TypeDID == InterfaceElementTypes.EntityList) this.entityListDEProcessing(args, casd, ie);
        if(ie.TypeDID == InterfaceElementTypes.FormEntity) this.entityViewDEProcessing(args, casd, ie);
        if(ie.TypeDID == InterfaceElementTypes.UXController|| ie.TypeDID == InterfaceElementTypes.ListUXController) this.uxControllerDEProcessing(args, casd, ie);
        if(ie.TypeDID == InterfaceElementTypes.Wizard) this.wizardDEProcessing(args, casd, ie);
      }
    }
  }


  entityViewDEProcessing(args, casd: AsdBase, ie: InterfaceElement){
    this.processedCASD = casd;
    let cieIndex : number = -1;
    let movedEntityItemID : string = args.el.id;
    let cie = new InterfaceElement(); 
    let interfaceElement = new InterfaceElement();
    this.toProcessIEList = [];
    
    cieIndex = this.processedCASD.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElementID);
    cie = this.processedCASD.InterfaceElements[cieIndex];
    for (let iee of ie.InterfaceElements) {
      if (movedEntityItemID == iee.InterfaceElementID) {
        let preIndex = cie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(iee.InterfaceElementID);
        if(preIndex > -1){
           interfaceElement = cie.InterfaceElements[preIndex];
        } else {
           interfaceElement.InterfaceElementID = iee.InterfaceElementID;
        }

        if(interfaceElement.Attributes == null){
         interfaceElement.Attributes = new Attribute();
        }
        
        if (args.target.id == 'AvailableEntities' && args.source.id == 'VisibleEntities') {
         interfaceElement.Attributes.Visible = false;
   
        }else if ( (args.target.id == 'VisibleEntities' && args.source.id == 'AvailableEntities') ||
                    (args.target.id == 'VisibleEntities' && args.source.id == 'VisibleEntities') ) {
         interfaceElement.Attributes.Visible = true;
        
        }
       
        this.toProcessIEList.push(interfaceElement);
        if(args.target.id == 'VisibleEntities'){
          for(let j=0; j<ie.InterfaceElements.length;j++){
            for(let i=1;i<args.target.rows.length;i++){
              if(ie.InterfaceElements[j].InterfaceElementID ==args.target.rows[i].id){
                if(ie.InterfaceElements[j].InterfaceElementID == interfaceElement.InterfaceElementID){
                  interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                }
                else{
                  let index = cie.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElements[j].InterfaceElementID);
                 
                  if(index>-1){
                    if(cie.InterfaceElements[index].Attributes == null){
                      cie.InterfaceElements[index].Attributes = new Attribute();
                    }
                    cie.InterfaceElements[index].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                  } else {
                    interfaceElement = new InterfaceElement();
                    interfaceElement.Attributes = new Attribute();
                    interfaceElement.InterfaceElementID = ie.InterfaceElements[j].InterfaceElementID;
                    interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                    this.toProcessIEList.push(interfaceElement);
                  } 
                }
                break;
              }
            }
          }
        }
        cie.InterfaceElements = this.getCustomIEList(this.toProcessIEList,cie.InterfaceElements,ie.TypeDID);
      }
    }
  } 



  uxControllerDEProcessing(args, casd: AsdBase, ie: InterfaceElement){
   
    this.processedCASD = casd;
    let cieIndex : number = -1;
    let movedUXControllerID : string = args.el.id;
    let cie = new InterfaceElement(); 
    let interfaceElement = new InterfaceElement();
    let matchedInterfaceElement = new InterfaceElement();
    let childIndex = -1;
    this.toProcessIEList = [];
          
  
    cieIndex = this.processedCASD.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElementID);
    cie = this.processedCASD.InterfaceElements[cieIndex];
    for(let iee of ie.InterfaceElements){
      if(iee.InterfaceElements != null){
        childIndex = iee.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(movedUXControllerID);
        if(childIndex >-1) {
            matchedInterfaceElement = iee.InterfaceElements[childIndex]; 
        }
      }
      else if(iee.InterfaceElements == null && iee.InterfaceElementID == movedUXControllerID){
        matchedInterfaceElement = iee;
      }

    
      if(matchedInterfaceElement != null && matchedInterfaceElement.InterfaceElementID!= null){
        
        let preIndex = cie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(matchedInterfaceElement.InterfaceElementID);
        if(preIndex>-1){
          interfaceElement = cie.InterfaceElements[preIndex];
        }
        else {
          interfaceElement.InterfaceElementID = matchedInterfaceElement.InterfaceElementID;
        }

        if(interfaceElement.Attributes == null) interfaceElement.Attributes = new Attribute();
        if (args.target.id == 'AvailableControls' && args.source.id == 'VisibleControls') {
          interfaceElement.Attributes.Active = false;
          
        }else if ( (args.target.id == 'VisibleControls' && args.source.id == 'AvailableControls') ||
                  (args.target.id == 'VisibleControls' && args.source.id == 'VisibleControls') ) {
            interfaceElement.Attributes.Active = true;
        }
       // console.log('INTERFACE ELEMENT DEFINITION: ', interfaceElement);
        this.toProcessIEList.push(interfaceElement);
        if(args.target.id == 'VisibleControls'){
          for(let j=0; j<ie.InterfaceElements.length;j++){
            for(let i=1;i<args.target.rows.length;i++){
              if(ie.InterfaceElements[j].InterfaceElements == null && ie.InterfaceElements[j].InterfaceElementID == args.target.rows[i].id){
                if(ie.InterfaceElements[j].InterfaceElementID == matchedInterfaceElement.InterfaceElementID){
                  interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                }
                else{
                  let index = cie.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElements[j].InterfaceElementID);
                 
                  if(index>-1){
                    if(cie.InterfaceElements[index].Attributes == null){
                      cie.InterfaceElements[index].Attributes = new Attribute();
                    }
                    cie.InterfaceElements[index].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                  } else {
                    interfaceElement = new InterfaceElement();
                    interfaceElement.Attributes = new Attribute();
                    interfaceElement.InterfaceElementID = ie.InterfaceElements[j].InterfaceElementID;
                    interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                    this.toProcessIEList.push(interfaceElement);
                  } 
                }
                
              }
              else if(ie.InterfaceElements[j].InterfaceElements != null){
                interfaceElement =  this.toProcessIEList[0];
                for(let iee of ie.InterfaceElements[j].InterfaceElements){
                  if(iee.InterfaceElementID == args.target.rows[i].id){
                    if(iee.InterfaceElementID == matchedInterfaceElement.InterfaceElementID){
                      interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                    }
                    else {
                      let index = cie.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(iee.InterfaceElementID);
                      if(index>-1){
                        if(cie.InterfaceElements[index].Attributes == null){
                          cie.InterfaceElements[index].Attributes = new Attribute();
                        }
                        cie.InterfaceElements[index].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                      }
                      else {
                        interfaceElement = new InterfaceElement();
                        interfaceElement.Attributes = new Attribute();
                        interfaceElement.InterfaceElementID = iee.InterfaceElementID;
                        interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                        this.toProcessIEList.push(interfaceElement);
                      } 
                    }
                    break;
                  }     
                }
              } 
            }
          }
        }
        cie.InterfaceElements = this.getCustomIEList(this.toProcessIEList,cie.InterfaceElements,ie.TypeDID);
        break;
      }
    }

     /*Old solution */
    /*for (let iee of ie.InterfaceElements) {
      if(iee.InterfaceElements == null && movedUXControllerID == iee.InterfaceElementID){
         let preIndex = cie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(iee.InterfaceElementID);
           if(preIndex > -1){
               interfaceElement = cie.InterfaceElements[preIndex];
           } else {
               interfaceElement.InterfaceElementID = iee.InterfaceElementID;
           }

           if(interfaceElement.Attributes == null){
               interfaceElement.Attributes = new Attribute();
           }

           if (args.target.id == 'AvailableControls' && args.source.id == 'VisibleControls') {
               interfaceElement.Attributes.Active = false;
               
           }else if ( (args.target.id == 'VisibleControls' && args.source.id == 'AvailableControls') ||
                      (args.target.id == 'VisibleControls' && args.source.id == 'VisibleControls') ) {
               interfaceElement.Attributes.Active = true;
           }
           this.toProcessIEList.push(interfaceElement);
           if(args.target.id == 'VisibleControls'){
           for(let j=0; j<ie.InterfaceElements.length;j++){
             for(let i=1;i<args.target.rows.length;i++){
               if(ie.InterfaceElements[j].InterfaceElementID ==args.target.rows[i].id){
                 if(ie.InterfaceElements[j].InterfaceElementID == interfaceElement.InterfaceElementID){
                   interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                 }
                 else{
                   let index = cie.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElements[j].InterfaceElementID);
                  
                   if(index>-1){
                     if(cie.InterfaceElements[index].Attributes == null){
                       cie.InterfaceElements[index].Attributes = new Attribute();
                     }
                     cie.InterfaceElements[index].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                   } else {
                     interfaceElement = new InterfaceElement();
                     interfaceElement.Attributes = new Attribute();
                     interfaceElement.InterfaceElementID = ie.InterfaceElements[j].InterfaceElementID;
                     interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                     this.toProcessIEList.push(interfaceElement);
                   } 
                 }
                 break;
               }
             }
           }
         }
        cie.InterfaceElements = this.getCustomIEList(this.toProcessIEList,cie.InterfaceElements,ie.TypeDID);
     }
     else if(iee.InterfaceElements!= null){
        let movedIndex = iee.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(movedUXControllerID);
        if(movedIndex > -1){
          let preIndex = cie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(iee.InterfaceElements[movedIndex].InterfaceElementID);
          if(preIndex > -1){
            interfaceElement = cie.InterfaceElements[preIndex];
          } else {
              interfaceElement.InterfaceElementID = iee.InterfaceElementID;
          }
          
          if(interfaceElement.Attributes == null){
            interfaceElement.Attributes = new Attribute();
          }

          if (args.target.id == 'AvailableControls' && args.source.id == 'VisibleControls') {
            interfaceElement.Attributes.Active = false;
            
          }else if ( (args.target.id == 'VisibleControls' && args.source.id == 'AvailableControls') ||
                   (args.target.id == 'VisibleControls' && args.source.id == 'VisibleControls') ) {
            interfaceElement.Attributes.Active = true;
          }
          this.toProcessIEList.push(interfaceElement);
          if(args.target.id == 'VisibleControls'){
            for(let j=0; j<ie.InterfaceElements.length;j++){
              for(let i=1;i<args.target.rows.length;i++){

              if(ie.InterfaceElements[j].InterfaceElements!= null){ 
                for(let k=0; k<ie.InterfaceElements[j].InterfaceElements.length; k++){
                  if(ie.InterfaceElements[j].InterfaceElements[k].InterfaceElementID == args.target.rows[i].id){
                   
                     if(ie.InterfaceElements[j].InterfaceElements[k].InterfaceElementID == interfaceElement.InterfaceElementID){
                      interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                     } else {
                      let childIndex = cie.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElements[j].InterfaceElements[k].InterfaceElementID);
                      if(childIndex>-1){
                            if(cie.InterfaceElements[childIndex].Attributes == null){
                              cie.InterfaceElements[childIndex].Attributes = new Attribute();
                            }
                            cie.InterfaceElements[childIndex].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                        }
                       else {
                           interfaceElement = new InterfaceElement();
                           interfaceElement.Attributes = new Attribute();
                           interfaceElement.InterfaceElementID = ie.InterfaceElements[j].InterfaceElements[k].InterfaceElementID;
                           interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                           this.toProcessIEList.push(interfaceElement);
                        }
                     }
                     break;
                    }
                  }
                }
                else if(ie.InterfaceElements[j].InterfaceElements == null){
                
                  if(ie.InterfaceElements[j].InterfaceElementID == args.target.rows[i].id){
                     let customIndex = cie.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElements[j].InterfaceElementID);
                     if(customIndex>-1){
                           if(cie.InterfaceElements[customIndex].Attributes == null){
                             cie.InterfaceElements[customIndex].Attributes = new Attribute();
                           }
                          cie.InterfaceElements[customIndex].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
    
                        }
                       else {
                           interfaceElement = new InterfaceElement();
                           interfaceElement.Attributes = new Attribute();
                           interfaceElement.InterfaceElementID = ie.InterfaceElements[j].InterfaceElementID;
                           interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                           this.toProcessIEList.push(interfaceElement);
                       }
                        break;
                     }
                  }
                }
              }
            }
          cie.InterfaceElements = this.getCustomIEList(this.toProcessIEList,cie.InterfaceElements,ie.TypeDID);
        }
     }
    }*/
  } 

  uxControllerDEProcessing1(args, casd: AsdBase, ie: InterfaceElement){
    this.processedCASD = casd;
    let cieIndex : number = -1;
    let movedUXControllerID : string = args.el.id;
    let cie = new InterfaceElement(); 
    let interfaceElement = new InterfaceElement();
    this.toProcessIEList = [];
          
  
    cieIndex = this.processedCASD.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElementID);
    cie = this.processedCASD.InterfaceElements[cieIndex];
    for (let iee of ie.InterfaceElements) {
       if(iee.InterfaceElements == null && movedUXControllerID == iee.InterfaceElementID){
          let preIndex = cie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(iee.InterfaceElementID);
            if(preIndex > -1){
                interfaceElement = cie.InterfaceElements[preIndex];
            } else {
                interfaceElement.InterfaceElementID = iee.InterfaceElementID;
            }

            if(interfaceElement.Attributes == null){
                interfaceElement.Attributes = new Attribute();
            }

            if (args.target.id == 'AvailableControls' && args.source.id == 'VisibleControls') {
                interfaceElement.Attributes.Active = false;
                
            }else if ( (args.target.id == 'VisibleControls' && args.source.id == 'AvailableControls') ||
                       (args.target.id == 'VisibleControls' && args.source.id == 'VisibleControls') ) {
                interfaceElement.Attributes.Active = true;
            }
            this.toProcessIEList.push(interfaceElement);
            if(args.target.id == 'VisibleControls'){
            for(let j=0; j<ie.InterfaceElements.length;j++){
              for(let i=1;i<args.target.rows.length;i++){
                if(ie.InterfaceElements[j].InterfaceElementID ==args.target.rows[i].id){
                  if(ie.InterfaceElements[j].InterfaceElementID == interfaceElement.InterfaceElementID){
                    interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                  }
                  else{
                    let index = cie.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(ie.InterfaceElements[j].InterfaceElementID);
                   
                    if(index>-1){
                      if(cie.InterfaceElements[index].Attributes == null){
                        cie.InterfaceElements[index].Attributes = new Attribute();
                      }
                      cie.InterfaceElements[index].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                    } else {
                      interfaceElement = new InterfaceElement();
                      interfaceElement.Attributes = new Attribute();
                      interfaceElement.InterfaceElementID = ie.InterfaceElements[j].InterfaceElementID;
                      interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                      this.toProcessIEList.push(interfaceElement);
                    } 
                  }
                  break;
                }
              }
            }
          }
         cie.InterfaceElements = this.getCustomIEList(this.toProcessIEList,cie.InterfaceElements,ie.TypeDID);
      }
    }

  } 

  entityListDEProcessing(args, casd: AsdBase, ie: InterfaceElement){
 
    let movedHeaderName : string = args.el.id; 
    this.processedCASD = casd;
    let headerItem : HeaderItem = new HeaderItem();
    this.toProcessIEList = [];

    for (let cie of this.processedCASD.InterfaceElements) {
      if (cie.InterfaceElementID == ie.InterfaceElementID) {
        headerItem = new HeaderItem();
        for(let h of ie.EntityList.HeaderItems){
          if(movedHeaderName == h.Name){
            let preIndex = cie.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf(h.Name);
            if(preIndex > -1){
                headerItem = cie.EntityList.HeaderItems[preIndex];
            } else {
                headerItem.Name = h.Name;
            }
                 
            if(headerItem.Attributes == null){
                headerItem.Attributes = new Attribute();
            }

            if (args.target.id == 'AvailableItems' && args.source.id == 'VisibleItems') {
                headerItem.Attributes.Visible = false;
              
            }else if ( (args.target.id == 'VisibleItems' && args.source.id == 'AvailableItems') ||
                       (args.target.id == 'VisibleItems' && args.source.id == 'VisibleItems') ) {
                headerItem.Attributes.Visible = true;
                                  
            }
            
            this.toProcessIEList.push(headerItem);
          }
          if(args.target.id == 'VisibleItems'){
            for(let i=1;i<args.target.rows.length;i++){
              if(h.Name ==args.target.rows[i].id){
               
                  if(h.Name == headerItem.Name){
                    headerItem.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                  }
                  else{
                    let index = cie.EntityList.HeaderItems.map(function(e) {return e.Name}).indexOf(h.Name);
                   
                    if(index>-1){
                      if(cie.EntityList.HeaderItems[index].Attributes == null){
                        cie.EntityList.HeaderItems[index].Attributes = new Attribute();
                      }
                      cie.EntityList.HeaderItems[index].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                    } else {
                      headerItem = new HeaderItem();
                      headerItem.Attributes = new Attribute();
                      headerItem.Name = h.Name;
                      headerItem.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
                      this.toProcessIEList.push(headerItem);
                    } 
                  }
                  break;
              }
            }
          }
        }
        
        cie.EntityList.HeaderItems = this.getCustomIEList(this.toProcessIEList,cie.EntityList.HeaderItems,ie.TypeDID);
       
      }
    }
  }

  wizardDEProcessing(args, casd: AsdBase, ie: InterfaceElement){
    this.processedCASD = casd;
    let groups: any[]=[];
    let draggedIEID: any;
    let casdIndex: number = -1;
    let calledGroup : InterfaceElement;
    let groupIndex: number  = -1;
    let interfaceElement = new InterfaceElement();
    this.toProcessIEList = [];

    groups = ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
    draggedIEID = args.el.cells[0].dataset.id;

    let preIndex = casd.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(draggedIEID);
    if(preIndex>-1){
      interfaceElement = casd.InterfaceElements[preIndex];
    } else {
      interfaceElement.InterfaceElementID = draggedIEID;
    }
   
    if(interfaceElement.Attributes == null){
      interfaceElement.Attributes = new Attribute();
    }
    
    interfaceElement.Attributes.GroupID = args.target.id;
    
    if(args.target.id =="UnAssignedElements"){
      delete  interfaceElement.Attributes.GroupID;
    }
    
    if(args.source.id == "UnAssignedElements" && args.target.id!= "UnAssignedElements"){
       
      // interfaceElement.Attributes.Visible = true;
    }

    this.toProcessIEList.push(interfaceElement);
    groupIndex = groups.map(function(e) {return e.InterfaceElementID}).indexOf(args.target.id);
    calledGroup = groups[groupIndex];
    if(groupIndex>-1){
      for(let i=0;i<args.target.rows.length;i++ ){
        casdIndex = casd.InterfaceElements.map(function(e) {return e.InterfaceElementID}).indexOf(args.target.rows[i].id);
        if(casdIndex > -1){
          casd.InterfaceElements[casdIndex].Attributes.DisplayOrder = args.target.rows[i].rowIndex;
        }
        else if(interfaceElement.InterfaceElementID ==args.target.rows[i].id ){
          interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
        }
        else {
          interfaceElement = new InterfaceElement();
          interfaceElement.Attributes = new Attribute();
          interfaceElement.InterfaceElementID = args.target.rows[i].id;
          interfaceElement.Attributes.DisplayOrder = args.target.rows[i].rowIndex;
          interfaceElement.Attributes.GroupID = groups[groupIndex].InterfaceElementID;
          this.toProcessIEList.push(interfaceElement);
        }
      }
    }
    else {
      this.toProcessIEList.push(interfaceElement);
    }
    casd.InterfaceElements = this.getCustomIEList(this.toProcessIEList,casd.InterfaceElements,ie.TypeDID);
    
  }

  saveEntityViewDEResults(dynaForm: any, dynaItem: any, actionType: any, ie:InterfaceElement){
    let interfaceElement = new InterfaceElement;
    let modifiedIEList: any[] = [];
    if (dynaForm != null) {
      this.oldIESpecs = {
        id: null,
        type: null,
        name : null,
        values: [],
        order: null,
        visible: null,
        active: null,
        sort: null,
        status: null,
        maskPattern: null,
        maskValue: null,
        displayFormat: null,
        width: null,
        height: null,
        alignment: null
      };
      for (let a of this.processedCASD.InterfaceElements) {
        if (a.InterfaceElementID == ie.InterfaceElementID) {
          interfaceElement = new InterfaceElement();
          let preIndex = a.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(dynaForm.ID);
          if(preIndex>-1){
             interfaceElement = a.InterfaceElements[preIndex];
          }
          else{
            interfaceElement.InterfaceElementID = dynaItem.InterfaceElementID;
          }
          this.updateDynaEditorDisplayNames(interfaceElement,dynaItem);
          modifiedIEList.push(interfaceElement);
          a.InterfaceElements = this.getCustomIEList(modifiedIEList, a.InterfaceElements,ie.TypeDID);
          for (let iee of a.InterfaceElements) {
            if (iee.InterfaceElementID == dynaForm.ID) {
              this.oldIESpecs.id = iee.InterfaceElementID;
              if(iee.Attributes!=null){
                this.oldIESpecs.order =  iee.Attributes.DisplayOrder;
                this.oldIESpecs.visible =  iee.Attributes.Visible;
                this.oldIESpecs.displayFormat = iee.Attributes.DisplayFormat;
              }
      
              if(iee.PreLabel!=null){
                this.oldIESpecs.values.push(iee.PreLabel.DisplayName);
                iee.PreLabel.DisplayName = dynaForm.displayName;
              }
              else if(iee.Label!=null){
                this.oldIESpecs.values.push(iee.Label.DisplayName);
                iee.Label.DisplayName = dynaForm.displayName;
              } else {
                this.oldIESpecs.values.push(iee.Name) ;
                iee.Name = dynaForm.displayName;
              }
              iee.Attributes.DisplayFormat = dynaForm.displayFormat;
             
              if(iee!=null && dynaForm!= null){
                let oldIESpecIndex = this.oldIESpecsList.map(function (d) {return d['id'];}).indexOf(this.oldIESpecs.id);
                if (oldIESpecIndex > -1) {
                  this.oldIESpecsList[oldIESpecIndex].values.push(this.oldIESpecs.values[0]);
                } else {
                  this.oldIESpecsList.push(this.oldIESpecs);
                }
              }
            }
          }
        }
      }
    }
    if(actionType == 'cancel'){
      if(ie.InterfaceElements!=null && ie.InterfaceElements.length>0){
        for (let iee of ie.InterfaceElements) {
          for (let o of this.oldIESpecsList) {          
            if(iee.InterfaceElements == null && iee.InterfaceElementID == o.id ){
              iee.DisplayProperties.DisplayName = o.values[0];
              iee[iee['DisplayProperties']['DisplaySrcKey']]['DisplayName'] = o.values[0];
              iee.Attributes.DisplayFormat = o.displayFormat;
            }
          }
        }
      }
      this.mediatorCASD =  cloneDeep(this.previousProcessedCASD);
      this.processedCASD = this.mediatorCASD;
      this.oldIESpecsList = [];
    }
    else if (actionType == 'save'|| actionType == 'update') {
      for(let cie of this.processedCASD.InterfaceElements){
        if(cie.InterfaceElementID == ie.InterfaceElementID){
          ie.InterfaceElements.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
          for(let et of ie.InterfaceElements){
            for(let ef of cie.InterfaceElements){
              if(et.InterfaceElementID == ef.InterfaceElementID){
                if(actionType=='update'){
                  this.updateDynaEditorDisplayNames(et,ef);
                  et.Attributes.DisplayFormat = ef.Attributes.DisplayFormat;
                }else if(actionType == 'save'){  
                  this.oldIESpecsList = [];     
                  Object.assign(et.Attributes, et.Attributes, ef.Attributes);
                }
                ie.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(ie);
              }
            }
          }
        }
      }
    }

  }
  saveUXControllerDEResults(dynaForm: any, dynaItem: any, actionType: any, ie:InterfaceElement){
    let interfaceElement = new InterfaceElement;
    let modifiedIEList: any[] = [];
    if (dynaForm != null) {
      this.oldIESpecs = {
        id: null,
        type: null,
        name : null,
        values: [],
        order: null,
        visible: null,
        active: null,
        sort: null,
        status: null,
        maskPattern: null,
        maskValue: null,
        displayFormat: null,
        width: null,
        height: null,
        alignment: null
      };
      for (let a of this.processedCASD.InterfaceElements) {
        if (a.InterfaceElementID == ie.InterfaceElementID) {
          interfaceElement = new InterfaceElement();
          let preIndex = a.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(dynaForm.ID);
          if(preIndex>-1){
             interfaceElement = a.InterfaceElements[preIndex];
          }
          else{
            interfaceElement.InterfaceElementID = dynaItem.InterfaceElementID;
          }
          this.updateDynaEditorDisplayNames(interfaceElement,dynaItem);
          modifiedIEList.push(interfaceElement);
          a.InterfaceElements = this.getCustomIEList(modifiedIEList, a.InterfaceElements,ie.TypeDID);
          for (let iee of a.InterfaceElements) {
            if (iee.InterfaceElementID == dynaForm.ID) {
              this.oldIESpecs.type = ie.TypeDID;
              this.oldIESpecs.id = iee.InterfaceElementID;
              if(iee.Attributes!= null){
                this.oldIESpecs.order =  iee.Attributes.DisplayOrder;
                if(ie.Attributes.Active == null || ie.Attributes.Active == true){
                  this.oldIESpecs.active = true;
                } else {
                  this.oldIESpecs.active = false;
                }
              }

              if (iee.PreLabel != null) {
                this.oldIESpecs.values.push(iee.PreLabel.DisplayName);
                iee.PreLabel.DisplayName = dynaForm.displayName;
              }
              else if (iee.Label != null) {
                this.oldIESpecs.values.push(iee.Label.DisplayName);
                iee.Label.DisplayName = dynaForm.displayName;
              } else {
                this.oldIESpecs.values.push(iee.Name);
                iee.Name = dynaForm.displayName;
              }
              this.oldIESpecs.sort = null;
             
              if(iee!=null && dynaForm!= null){
                let oldIESpecIndex = this.oldIESpecsList.map(function (d) {return d['id'];}).indexOf(this.oldIESpecs.id);
                if (oldIESpecIndex > -1) {
                  this.oldIESpecsList[oldIESpecIndex].values.push(this.oldIESpecs.values[0]);
                } else {
                  this.oldIESpecsList.push(this.oldIESpecs);
                }
              }
            }
          }
        }
      }
    }
    if(actionType == 'cancel'){
      if(ie.InterfaceElements!=null && ie.InterfaceElements.length>0){
        for (let iee of ie.InterfaceElements) {
          for (let o of this.oldIESpecsList) {
            if(iee.InterfaceElements == null && iee.InterfaceElementID == o.id ){
              iee.DisplayProperties.DisplayName = o.values[0];
              iee[iee['DisplayProperties']['DisplaySrcKey']]['DisplayName'] = o.values[0];
            }
            if(iee.InterfaceElements != null){
              for(let ieee of iee.InterfaceElements){
                if(ieee.InterfaceElementID == o.id){
                  ieee.DisplayProperties.DisplayName = o.values[0];
                  ieee[ieee['DisplayProperties']['DisplaySrcKey']]['DisplayName'] = o.values[0];
                }
              }
            }
          }
        }
      }
      this.mediatorCASD =  cloneDeep(this.previousProcessedCASD);
      this.processedCASD = this.mediatorCASD;
      this.oldIESpecsList = [];

    }
    else if (actionType == 'save'|| actionType == 'update') {
      for(let cie of this.processedCASD.InterfaceElements){
        if(cie.InterfaceElementID == ie.InterfaceElementID){
          ie.InterfaceElements.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
          for(let et of ie.InterfaceElements){
            for(let ef of cie.InterfaceElements){
              if(et.InterfaceElementID == ef.InterfaceElementID){
                if(actionType=='update'){
                  this.updateDynaEditorDisplayNames(et,ef);
                }else if(actionType == 'save'){ 
                  this.oldIESpecsList = [];     
                  Object.assign(et.Attributes, et.Attributes, ef.Attributes);
                }
                ie.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(ie);
                
              }
              if(et.InterfaceElements!= null){
                let index = et.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(ef.InterfaceElementID);
                if(index>-1){
                  if(actionType == 'update'){
                    this.updateDynaEditorDisplayNames(et.InterfaceElements[index], ef);
                  } else if(actionType == 'save'){
                    this.oldIESpecsList = [];
                    Object.assign(et.InterfaceElements[index].Attributes, et.InterfaceElements[index].Attributes, ef.Attributes);

                  }
                  ie.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(ie);
                }
              }
              
            }
          }
        }
      }
    }
    
  }
 
  saveEntityListDEResults(dynaForm: any, dynaItem: any, actionType: any, ie:InterfaceElement){
   
    let modifiedIEList: any[] = [];
    let headerItem : HeaderItem = new HeaderItem();
    if (dynaForm != null ) {
      this.oldIESpecs = {
        id: null,
        type: null,
        name : null,
        values: [],
        order: null,
        visible: null,
        active: null,
        sort: null,
        status: null,
        maskPattern: null,
        maskValue: null,
        displayFormat: null,
        width: null,
        height: null,
        alignment: null
      };
      for (let a of this.processedCASD.InterfaceElements) {
        if (a.InterfaceElementID == ie.InterfaceElementID) {
          headerItem = new HeaderItem();
          let preIndex = a.EntityList.HeaderItems.map(function(e){return e.Name}).indexOf(dynaForm.ID);
          if(preIndex>-1){
            headerItem = a.EntityList.HeaderItems[preIndex];
          }
          else{
            headerItem.Name = dynaItem.Name;
            
          }
          headerItem.DisplayName= dynaItem.DisplayName;
          headerItem.AllowSorting = dynaItem.AllowSorting;
          if(headerItem.Attributes == null) headerItem.Attributes = new Attribute();
       
          if(headerItem.Attributes.Mask == null) headerItem.Attributes.Mask = new MaskAttributes();
          modifiedIEList.push(headerItem);
          a.EntityList.HeaderItems = this.getCustomIEList(modifiedIEList, a.EntityList.HeaderItems,ie.TypeDID);
          for (let h of a.EntityList.HeaderItems) {
            if (h.Name == dynaForm.ID) {
              this.oldIESpecs.type = ie.TypeDID;
              this.oldIESpecs.id = h.Name;
              this.oldIESpecs.name = h.Name;
              this.oldIESpecs.sort = h.AllowSorting;
              this.oldIESpecs.values.push(h.DisplayName);
              if(h.Attributes!= null){
                this.oldIESpecs.order =  h.Attributes.DisplayOrder;
                this.oldIESpecs.visible =  h.Attributes.Visible;
                this.oldIESpecs.maskPattern = h.Attributes.Mask.Pattern;
                this.oldIESpecs.maskValue = h.Attributes.Mask.Value;
                this.oldIESpecs.displayFormat = h.Attributes.DisplayFormat;
                this.oldIESpecs.width = h.Attributes.Width;
                this.oldIESpecs.height = h.Attributes.Height;
                this.oldIESpecs.alignment = h.Attributes.Alignment;
              }
              h.DisplayName = dynaForm.displayName;
              h.AllowSorting = dynaForm.allowSort;
              h.Editable = dynaForm.isEditable;
              h.Attributes.Mask.Pattern = dynaForm.maskPattern;
              h.Attributes.Mask.Value = dynaForm.maskValue;
              h.Attributes.DisplayFormat = dynaForm.displayFormat;
              h.Attributes.Width = dynaForm.width;
              h.Attributes.Height = dynaForm.height;
              h.Attributes.Alignment = dynaForm.alignment;
              
              if(h!=null && dynaForm!= null){
                let oldIESpecIndex = this.oldIESpecsList.map(function (d) {return d['name'];}).indexOf(this.oldIESpecs.id);
                if (oldIESpecIndex > -1) {
                 this.oldIESpecsList[oldIESpecIndex].values.push(this.oldIESpecs.values[0]);
                } else {
                  this.oldIESpecsList.push(this.oldIESpecs);
                }
              } 
            }
          }
        }
      }
    }
    if (actionType == 'cancel'){
      if(ie.EntityList.HeaderItems.length>0){
        for(let header of ie.EntityList.HeaderItems){
          for (let o of this.oldIESpecsList) {
            if (o.name == header.Name) {
              header.DisplayName = o.values[0];
              header.AllowSorting = o.sort;
              header.Attributes.DisplayFormat = o.displayFormat;
              header.Attributes.Width = o.width;
              header.Attributes.Height = o.height;
              header.Attributes.Alignment = o.alignment;
              if(header.Attributes.Mask!= null){
                header.Attributes.Mask.Pattern = o.maskPattern;
                header.Attributes.Mask.Value = o.maskValue;
              }
            }
          }
        }
      }

      this.mediatorCASD =  cloneDeep(this.previousProcessedCASD);
      this.processedCASD = this.mediatorCASD;
      this.oldIESpecsList = [];

    }
    else if (actionType == 'save'|| actionType == 'update') {
      for(let cie of this.processedCASD.InterfaceElements){
        if(cie.InterfaceElementID == ie.InterfaceElementID){
          for(let hie of cie.EntityList.HeaderItems){
            let hIndex = ie.EntityList.HeaderItems.map(function(e) {return e.Name}).indexOf(hie.Name);
            if(hIndex>-1){
              if(actionType=='update'){
                if(hie.DisplayName != null){
                  ie.EntityList.HeaderItems[hIndex].DisplayName = hie.DisplayName;
                  ie.EntityList.HeaderItems[hIndex].AllowSorting = hie.AllowSorting;
                  ie.EntityList.HeaderItems[hIndex].Editable = hie.Editable;
                  if(hie.Attributes.Mask!= null){
                    if(ie.EntityList.HeaderItems[hIndex].Attributes.Mask == null) ie.EntityList.HeaderItems[hIndex].Attributes.Mask = new MaskAttributes();
                    ie.EntityList.HeaderItems[hIndex].Attributes.Mask.Pattern = hie.Attributes.Mask.Pattern;
                    ie.EntityList.HeaderItems[hIndex].Attributes.Mask.Value = hie.Attributes.Mask.Value;
                  }
                  ie.EntityList.HeaderItems[hIndex].Attributes.DisplayFormat = hie.Attributes.DisplayFormat;

                  ie.EntityList.HeaderItems[hIndex].Attributes.Width = hie.Attributes.Width;
                  ie.EntityList.HeaderItems[hIndex].Attributes.Height = hie.Attributes.Height;
                  ie.EntityList.HeaderItems[hIndex].Attributes.Alignment = hie.Attributes.Alignment;

                }
              } else if(actionType == 'save'){   
                Object.assign(ie.EntityList.HeaderItems[hIndex].Attributes, ie.EntityList.HeaderItems[hIndex].Attributes, hie.Attributes);
                this.oldIESpecsList = [];
              }
            }
          }
        }
      }
    }
  }

  saveWizardDEResults(dynaForm: any, dynaItem: any, actionType: any, ie:InterfaceElement){
    let interfaceElement = new InterfaceElement(); 
   
    let modifiedIEList: any[] = [];
    let groupList: any[] = [];
    let nongroupList: any[] = [];
    let preIndex : number = -1;         
    groupList.push( ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups));
   
    for(let iee of ie.InterfaceElements){
      if(iee.TypeDID !== InterfaceElementTypes.Groups){
        nongroupList.push(iee);
      }
    }

    
    if(dynaForm!= null){
   
      let gpReferencedIEID: InterfaceElement= new InterfaceElement();
      let groups =  ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
      
    
      if(dynaForm.groupID !== '' && dynaItem.TypeDID == InterfaceElementTypes.Group){
        preIndex = this.processedCASD.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(dynaForm.groupID);
      
        interfaceElement = new InterfaceElement();
        if(preIndex>-1){
            interfaceElement = this.processedCASD.InterfaceElements[preIndex];
        }
        else{
            interfaceElement.InterfaceElementID = dynaForm.groupID;   
            interfaceElement.InterfaceElements = []; 
        }
        interfaceElement =  this.updateGroupHeader(ie, interfaceElement, dynaForm);
        modifiedIEList.push(interfaceElement);
      }

      else if(dynaForm.groupID == ''){
        preIndex = this.processedCASD.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(dynaForm.ID);
        if(preIndex>-1){
          interfaceElement = this.processedCASD.InterfaceElements[preIndex];
        }
        else{
            interfaceElement.InterfaceElementID = dynaItem.InterfaceElementID;
            interfaceElement.Attributes = new Attribute();  
        }
        interfaceElement.Attributes.Visible = dynaItem.Attributes.Visible;
        gpReferencedIEID = this.findIEFromGroups(interfaceElement,groups,ie,true);
        if(gpReferencedIEID!= null){
          interfaceElement= this.setDisplayNamesFromDynaFormEditor(dynaItem,gpReferencedIEID,interfaceElement);
        }
      
        
        if(dynaItem.TypeDID == InterfaceElementTypes.Group){
          interfaceElement.TypeDID = InterfaceElementTypes.Group;
          interfaceElement.InterfaceElements = [];
          interfaceElement = this.setGroupAssignment(interfaceElement, ie);
        }
        
        modifiedIEList.push(interfaceElement);
      }
      
      this.processedCASD.InterfaceElements = this.getCustomIEList(modifiedIEList,this.processedCASD.InterfaceElements,ie.TypeDID);
      for (let iee of this.processedCASD.InterfaceElements ) {
        if (iee.InterfaceElementID == dynaForm.ID && iee.TypeDID != InterfaceElementTypes.Groups ) {
          iee = this.updateDisplaynOldSpecs(iee, dynaForm);
        }
        else if(iee.InterfaceElements != null || iee.TypeDID == InterfaceElementTypes.Groups){

          let gIndex = iee.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(dynaForm.ID);
          if(gIndex>-1){
            iee.InterfaceElements[gIndex] = this.updateDisplaynOldSpecs(iee.InterfaceElements[gIndex], dynaForm);
            if(dynaForm.displayOrder !== iee.InterfaceElements[gIndex].Attributes.DisplayOrder){
              iee = this.updateGroupHeadDisplayOrder(iee, dynaForm);
            }
            if(dynaForm.visible == false) {
              let nextActiveGroup: InterfaceElement = this.updateActivationOnGroupHeader(gIndex,iee);
              if(nextActiveGroup!= null && nextActiveGroup.Attributes.Active == false ){
                let nextDynaForm : any = {ID: nextActiveGroup.InterfaceElementID, groupID: iee.InterfaceElementID ,active: true, displayName: nextActiveGroup.Label.DisplayName, visible: nextActiveGroup.Attributes.Visible};
                let nextgIndex = iee.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(nextActiveGroup.InterfaceElementID);
                if(nextgIndex > -1){
                
                  iee.InterfaceElements[nextgIndex] = this.updateDisplaynOldSpecs(iee.InterfaceElements[nextgIndex], nextDynaForm);
                }
              }
            }
            else if(dynaForm.visible == true){
              
            } 
          }
        }
      }
    }

    if (actionType == 'cancel') {
      for (let element of groupList) {
        for (let o of this.oldIESpecsList) {
          for(let group of element.InterfaceElements){
            if(group.InterfaceElementID == o.id){
              group.Attributes.DisplayOrder = o.order;
            }
            for(let gie of group.InterfaceElements){
              if(gie.InterfaceElementID == o.id ){
                 gie.Attributes.Visible = o.visible;
                 gie.DisplayProperties.DisplayName = o.values[0];
                 if(gie.PreLabel!=null) gie.PreLabel.DisplayName = o.values[0]; 
                 else if(gie.Label!=null) gie.Label.DisplayName = o.values[0]; 
                 else if(gie.Name!= null) gie.Name = o.values[0];
                 group.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(group);
              }
            }
            if(o.id == group.InterfaceElementID && o.status == null ){
              group.Attributes.Visible = o.visible;
              group.Attributes.Active = o.active;
              group.DisplayProperties.DisplayName = o.values[0];
              if(group.PreLabel!=null) group.PreLabel.DisplayName = o.values[0]; 
              else if(group.Label!=null) group.Label.DisplayName = o.values[0]; 
              else if(group.Name!= null) group.Name = o.values[0];


            }
            else if(o.id == group.InterfaceElementID && o.status == 'NEW'){
              let groupIndex = element.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(o.id);
              element.InterfaceElements.splice(groupIndex,1);
            }
          }
        }
      }

      for(let element of nongroupList){
        for(let o of this.oldIESpecsList){
          if(element.InterfaceElementID == o.id){
            element.DisplayProperties.DisplayName = o.values[0];
            if(element.PreLabel!= null) element.PreLabel.DisplayName = o.values[0];
            if(element.Attributes!= null) element.Attributes.Visible = o.visible;
          }
        }
      }
      
      this.mediatorCASD =  cloneDeep(this.previousProcessedCASD);
      this.processedCASD = this.mediatorCASD;
      this.oldIESpecsList = [];
    }
    else if(actionType == 'save'|| actionType == 'update'){
      let nonGpIndex: number = -1;
      let gpIndex: number = -1;
      let mainGroupIndex: number = -1;
      let groups =  ie.InterfaceElements.find(element => element.TypeDID == InterfaceElementTypes.Groups).InterfaceElements;
    
      for(let cie of this.processedCASD.InterfaceElements){ 
        nonGpIndex = ie.InterfaceElements.map(function(i){return i.InterfaceElementID}).indexOf(cie.InterfaceElementID);
        
        if(nonGpIndex>-1){
          if(actionType == "update"){
            if(cie.PreLabel!= null){
              ie.InterfaceElements[nonGpIndex].PreLabel.DisplayName = cie.PreLabel.DisplayName;
              ie.InterfaceElements[nonGpIndex].DisplayProperties.DisplayName =  ie.InterfaceElements[nonGpIndex].PreLabel.DisplayName;
            }
            else if(cie.Label!= null){
              ie.InterfaceElements[nonGpIndex].Label.DisplayName = cie.Label.DisplayName;
              ie.InterfaceElements[nonGpIndex].DisplayProperties.DisplayName =  ie.InterfaceElements[nonGpIndex].Label.DisplayName;
            }
            else if(cie.Name!=null){
              ie.InterfaceElements[nonGpIndex].Name = cie.Name;
              ie.InterfaceElements[nonGpIndex].DisplayProperties.DisplayName =  ie.InterfaceElements[nonGpIndex].Name;
            }          
            else if(cie.InterfaceElements!= null && ie.InterfaceElements[nonGpIndex].TypeDID == InterfaceElementTypes.Groups){
              let newGroupMembers = cie.InterfaceElements.filter(o1 => !ie.InterfaceElements[nonGpIndex].InterfaceElements.some(o2 => o1.InterfaceElementID === o2.InterfaceElementID)); 
              if(newGroupMembers!= null && newGroupMembers.length > 0){
                for(let ng of newGroupMembers){
                  ng.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(ng);
                  ie.InterfaceElements[nonGpIndex].InterfaceElements.push(ng);
                }
              }
            
              if(cie.InterfaceElementID == ie.InterfaceElements[nonGpIndex].InterfaceElementID){
              
                for(let c=0; c<cie.InterfaceElements.length;c++){
                 let index =  ie.InterfaceElements[nonGpIndex].InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(cie.InterfaceElements[c].InterfaceElementID)
                 if(index>-1){
                   if(cie.InterfaceElements[c].Attributes.DisplayOrder!= null) ie.InterfaceElements[nonGpIndex].InterfaceElements[index].Attributes.DisplayOrder = cie.InterfaceElements[c].Attributes.DisplayOrder;
                   if(cie.InterfaceElements[c].Attributes.Active!= null) ie.InterfaceElements[nonGpIndex].InterfaceElements[index].Attributes.Active = cie.InterfaceElements[c].Attributes.Active;
                   if(cie.InterfaceElements[c].Attributes.Visible!= null) ie.InterfaceElements[nonGpIndex].InterfaceElements[index].Attributes.Visible = cie.InterfaceElements[c].Attributes.Visible;
                  }
                }
              }
              
              
              for(let iee of ie.InterfaceElements[nonGpIndex].InterfaceElements){
                mainGroupIndex = cie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(iee.InterfaceElementID);
                if(mainGroupIndex>-1){
                  if(cie.InterfaceElements[mainGroupIndex].PreLabel!= null){
                    iee.PreLabel.DisplayName = cie.InterfaceElements[mainGroupIndex].PreLabel.DisplayName;
                    iee.DisplayProperties.DisplayName =  iee.PreLabel.DisplayName;
                  }
                  else if(cie.InterfaceElements[mainGroupIndex].Label!= null){
                    iee.Label.DisplayName = cie.InterfaceElements[mainGroupIndex].Label.DisplayName;
                    iee.DisplayProperties.DisplayName =  iee.Label.DisplayName;
                  }
                  else if(cie.InterfaceElements[mainGroupIndex].Name!=null){
                    iee.Name = cie.InterfaceElements[mainGroupIndex].Name;
                    iee.DisplayProperties.DisplayName =  iee.Name;
                  }
                }
              }  
            }

            if(cie.Attributes!= null){
              ie.InterfaceElements[nonGpIndex].Attributes.Visible = cie.Attributes.Visible;
            }
            
          }
          if(actionType == "save" && cie.Attributes!= null){
           
              ie.InterfaceElements[nonGpIndex].Attributes.DisplayOrder = cie.Attributes.DisplayOrder;
              ie.InterfaceElements[nonGpIndex].Attributes.GroupID = cie.Attributes.GroupID;
              this.oldIESpecsList = [];
            
          }
        }
        else if(nonGpIndex<0){
         
          for(let group of groups){
            gpIndex = group.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(cie.InterfaceElementID);
            if(gpIndex>-1){
              if(actionType == "update"){
                if(cie.PreLabel!= null){
                  group.InterfaceElements[gpIndex].PreLabel.DisplayName = cie.PreLabel.DisplayName;
                  group.InterfaceElements[gpIndex].DisplayProperties.DisplayName =  group.InterfaceElements[gpIndex].PreLabel.DisplayName;
                }
                else if(cie.Label!= null){
                  group.InterfaceElements[gpIndex].Label.DisplayName = cie.Label.DisplayName;
                  group.InterfaceElements[gpIndex].DisplayProperties.DisplayName =  group.InterfaceElements[gpIndex].Label.DisplayName;
                }
                else if(cie.Name!=null){
                  group.InterfaceElements[gpIndex].Name = cie.Name;
                  group.InterfaceElements[gpIndex].DisplayProperties.DisplayName =  group.InterfaceElements[gpIndex].Name;
                }

                if(cie.Attributes!=null && cie.Attributes.Visible!= null){
                  group.InterfaceElements[gpIndex].Attributes.Visible = cie.Attributes.Visible;
                  group.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(group);
                }
              }
              if(actionType == "save" && cie.Attributes!= null){
                group.InterfaceElements[gpIndex].Attributes.DisplayOrder = cie.Attributes.DisplayOrder;
                group.InterfaceElements[gpIndex].Attributes.GroupID = cie.Attributes.GroupID;
                group.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(group);
                this.oldIESpecsList = [];
              }
              
            break;
            }
          }
        }
      }
    } 
  }

  updateGroupHeadDisplayOrder(interfaceElement:InterfaceElement, dynaForm){
     
    let newDisplayOrder : number = parseInt(dynaForm.displayOrder);
    let calledDisplayOrder: number = -1;
    let otherDynaForm: any;
   
    let gIEList: InterfaceElement[] = [];
    gIEList = cloneDeep(interfaceElement.InterfaceElements.sort((a,b)=> a.Attributes.DisplayOrder - b.Attributes.DisplayOrder));
   
    let calledIndex = gIEList.map(function(e){return e.InterfaceElementID}).indexOf(dynaForm.ID);
    if (calledIndex> -1){
      calledDisplayOrder = gIEList[calledIndex].Attributes.DisplayOrder;
      for(let gie of gIEList){  
        if(calledDisplayOrder>-1 && gie.InterfaceElementID !== dynaForm.ID){
          if(calledDisplayOrder < newDisplayOrder){
            if(gie.Attributes.DisplayOrder >= calledDisplayOrder && gie.Attributes.DisplayOrder <= newDisplayOrder){
                 otherDynaForm = {ID: gie.InterfaceElementID, displayName: gie.Label.DisplayName, displayOrder: gie.Attributes.DisplayOrder, groupID: dynaForm.groupID, visible: gie.Attributes.Visible, name: gie.Name};
                 gie = this.updateDisplaynOldSpecs(gie, otherDynaForm);
                 gie.Attributes.DisplayOrder = gie.Attributes.DisplayOrder - 1;
              }
            }
            else if(calledDisplayOrder > newDisplayOrder){
              if(gie.Attributes.DisplayOrder >= newDisplayOrder && gie.Attributes.DisplayOrder <= calledDisplayOrder){
                otherDynaForm = {ID: gie.InterfaceElementID,  displayName: gie.Label.DisplayName, displayOrder: gie.Attributes.DisplayOrder, groupID: dynaForm.groupID, visible: gie.Attributes.Visible, name: gie.Name};
                gie = this.updateDisplaynOldSpecs(gie, otherDynaForm);
                gie.Attributes.DisplayOrder = gie.Attributes.DisplayOrder + 1; 
              }
            }
          }
          if(gie.InterfaceElementID == dynaForm.ID){
            gie.Attributes.DisplayOrder =  newDisplayOrder;
          }
        }
       }
     
       interfaceElement.InterfaceElements = [];
       interfaceElement.InterfaceElements = gIEList;               

    return interfaceElement;

  }

  chkPostGroupActiveHeader(index, ie){
    ie.InterfaceElements =  ie.InterfaceElements.sort( (a,b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
    let activeGroupIE: InterfaceElement;
    for(let gie = index; gie<ie.InterfaceElements.length; gie++){
      if(ie.InterfaceElements[gie].Attributes.Visible && ie.InterfaceElements[gie].Attributes.Active ){
        activeGroupIE = ie.InterfaceElements[gie];
        break;
      }
    }
    if(activeGroupIE == null){
      for(let gie = index; gie<ie.InterfaceElements.length; gie++){
        if(ie.InterfaceElements[gie].Attributes.Visible ){
          activeGroupIE = ie.InterfaceElements[gie];
          break;
        }
      }
    }
    return activeGroupIE;
  }

  chkPreGroupActiveHeader(index, ie){
    ie.InterfaceElements =  ie.InterfaceElements.sort( (a,b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
    let activeGroupIE: InterfaceElement;
    for(let gie = 0 ; gie<index ; gie++){
      if(ie.InterfaceElements[gie].Attributes.Visible && ie.InterfaceElements[gie].Attributes.Active ){
        activeGroupIE = ie.InterfaceElements[gie];
        break;
      }
    }
    if(activeGroupIE == null){
      for(let gie = 0; gie<index; gie++){
        if(ie.InterfaceElements[gie].Attributes.Visible ){
          activeGroupIE = ie.InterfaceElements[gie];
          break;
        }
      }
    }
    return activeGroupIE;
  }

  updateActivationOnGroupHeader(index:number, ie: InterfaceElement){
    
    let activeGroupIE: InterfaceElement;

    if(index == 0){
      activeGroupIE = this.chkPostGroupActiveHeader(0, ie);
    }

    else if(index == ie.InterfaceElements.length - 1){
      activeGroupIE = this.chkPreGroupActiveHeader(index, ie);
    }

    else if(index > 0 && index < ie.InterfaceElements.length){
      activeGroupIE = this.chkPreGroupActiveHeader(index, ie);
      if(activeGroupIE == null){
        activeGroupIE = this.chkPostGroupActiveHeader(index, ie);
      }
    }

    return activeGroupIE;
  }

  updateGroupHeader(ie: InterfaceElement, cie: InterfaceElement, dynaForm){
    let ieIndex : number = -1;
    if(ie.InterfaceElements!= null && ie.InterfaceElements.length > 0){
      ieIndex = ie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(cie.InterfaceElementID);
      if(ieIndex> -1){
        for(let iee of ie.InterfaceElements[ieIndex].InterfaceElements){
          let cieIndex = cie.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(iee.InterfaceElementID);
          if(cieIndex>-1){
            if(cie.InterfaceElements[cieIndex].Attributes!= null){
              if(cie.InterfaceElements[cieIndex].Attributes.DisplayOrder == null){
                cie.InterfaceElements[cieIndex].Attributes.DisplayOrder = iee.Attributes.DisplayOrder;
              }
              if(cie.InterfaceElements[cieIndex].Attributes.Active == null){
                cie.InterfaceElements[cieIndex].Attributes.Active = iee.Attributes.Active; 
              }
            }
            if(cie.InterfaceElements[cieIndex].Attributes == null){
              cie.InterfaceElements[cieIndex].Attributes = new Attribute();
              cie.InterfaceElements[cieIndex].Attributes.DisplayOrder = iee.Attributes.DisplayOrder;
              cie.InterfaceElements[cieIndex].Attributes.Active = iee.Attributes.Active;
            }
          } 
          else if(cieIndex<0){
            let ieNew = new InterfaceElement();
            ieNew.InterfaceElementID = iee.InterfaceElementID;
            ieNew.Attributes = new Attribute();
            ieNew.Attributes.DisplayOrder =  iee.Attributes.DisplayOrder;
            ieNew.Attributes.Visible = iee.Attributes.Visible;
            ieNew.Attributes.Active = iee.Attributes.Active;
            ieNew.InterfaceElements=[];
            ieNew.Label = new IELabel();
            ieNew.Label.DisplayName = iee.Label.DisplayName;
            cie.InterfaceElements.push(ieNew);
          }       
        }
      }
    }

    return cie;
  }

  nextLargestDisplayOrder(ieList:InterfaceElement[], displayOrder: number){
    let nextLargest: number = -1;
    for(let i=0; i<ieList.length; i++){
      if(ieList[i].Attributes!= null && ieList[i].Attributes.DisplayOrder!= null && ieList[i].Attributes.DisplayOrder > displayOrder){
        nextLargest = i;
        break;
      }
    }
    return nextLargest;
  }
  
   updateDisplaynOldSpecs(iee : InterfaceElement, dynaForm){
  
    this.oldIESpecs = {
      id: null,
      type: null,
      name : null,
      values: [],
      order: null,
      visible: null,
      active: null,
      sort: null,
      status:null,
      maskPattern: null,
      maskValue: null,
      displayFormat: null,
      width: null,
      height: null,
      alignment: null
    };  
    this.oldIESpecs.id = iee.InterfaceElementID;     
    if(iee.Attributes!=null){
      this.oldIESpecs.order= iee.Attributes.DisplayOrder;
      this.oldIESpecs.visible= iee.Attributes.Visible;
      this.oldIESpecs.active = iee.Attributes.Active;
      iee.Attributes.Visible = dynaForm.visible;
      if(dynaForm.active == null) {
        if(!iee.Attributes.Visible && iee.Attributes.Active) iee.Attributes.Active = false; 
      } else {
        iee.Attributes.Active = dynaForm.active;
      }
    }  
    
    if(iee.Label == null && iee.TypeDID == InterfaceElementTypes.Group){
      iee.Label = new IELabel();
      iee.Label.DisplayName= dynaForm.displayName;
      iee.DisplayProperties = new IEDisplayProperties();
      this.oldIESpecs.status = 'NEW';
    }
    
    if(iee.PreLabel!=null){
      this.oldIESpecs.values.push(iee.PreLabel.DisplayName);
      iee.PreLabel.DisplayName = dynaForm.displayName;
    }
    else if(iee.Label!=null){
      this.oldIESpecs.values.push(iee.Label.DisplayName);
      iee.Label.DisplayName = dynaForm.displayName;
    } else {
      this.oldIESpecs.values.push(iee.Name);
      iee.Name = dynaForm.displayName;
    }

    if(iee!=null && dynaForm!= null){
      let oldIESpecIndex = this.oldIESpecsList.map(function (d) {return d['id'];}).indexOf(this.oldIESpecs.id);
      if (oldIESpecIndex > -1) {
        this.oldIESpecsList[oldIESpecIndex].values.push(this.oldIESpecs.values[0]);
      } else {
        this.oldIESpecsList.push(this.oldIESpecs);
      }
    }
    return iee;
  }

  setGroupAssignment(groupItem: InterfaceElement, wizardIE: InterfaceElement){
   let interfaceElement : InterfaceElement = new InterfaceElement();
    for(let wie of wizardIE.InterfaceElements){
      if(wie.TypeDID == InterfaceElementTypes.Groups){
        for(let gie of wie.InterfaceElements){
          if(gie.InterfaceElementID == groupItem.InterfaceElementID){
            interfaceElement.InterfaceElementID = wie.InterfaceElementID;
            interfaceElement.InterfaceElements = [];
            interfaceElement.InterfaceElements.push(groupItem);
          }
          else {
            interfaceElement.InterfaceElementID = wie.InterfaceElementID;
            interfaceElement.InterfaceElements = [];
            interfaceElement.InterfaceElements.push(groupItem);
          }
        }
      }
    }
    
    return interfaceElement;
  }
  
  getCustomIEList(itemList: any, list: any[], type: any ){
    let chkIndexIE : number = -1;
    if(type == InterfaceElementTypes.FormEntity || 
       type == InterfaceElementTypes.UXController ||  
       type == InterfaceElementTypes.ListUXController) {
    
      for(let item=0; item<itemList.length; item++){
        chkIndexIE = list.map(function(i){return i.InterfaceElementID}).indexOf(itemList[item].InterfaceElementID);
        if(chkIndexIE < 0){
            list.push(itemList[item]);
          } else {
            Object.assign(list[chkIndexIE], list[chkIndexIE], itemList[item]);
          }
      }
      //console.log('ItemLIST: ', itemList);
       
    }
    else if(type == InterfaceElementTypes.EntityList){
      for(let item=0; item<itemList.length; item++){
        chkIndexIE = list.map(function(i){return i.Name}).indexOf(itemList[item].Name);
      
        if(chkIndexIE < 0){
          list.push(itemList[item]);
        } else {
          Object.assign(list[chkIndexIE], list[chkIndexIE], itemList[item]);
        }
      }
    }
    else if(type == InterfaceElementTypes.Wizard){
      let chkGroupIndex: number = -1;
      for(let item=0; item<itemList.length; item++){
        chkIndexIE = list.map(function(i){return i.InterfaceElementID}).indexOf(itemList[item].InterfaceElementID);
        if(chkIndexIE < 0){
          list.push(itemList[item]);
        } else {
          if(itemList[item].InterfaceElements != null  && list[chkIndexIE].InterfaceElementID == itemList[item].InterfaceElementID){
            chkGroupIndex = list[chkIndexIE].InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(itemList[item].InterfaceElements[0].InterfaceElementID)
            if(chkGroupIndex<0){
              list[chkIndexIE].InterfaceElements.push(itemList[item].InterfaceElements[0])
            }
          }
          else {

            Object.assign(list[chkIndexIE], list[chkIndexIE], itemList[item]);
          }
        }
      }
    }
    return list;
  }

  updateDynaEditorDisplayNames(toIE: InterfaceElement, fromIE: InterfaceElement){
    if(fromIE.PreLabel!= null){
      if(toIE.PreLabel==null) toIE.PreLabel = new IELabel();
      toIE.PreLabel.DisplayName = fromIE.PreLabel.DisplayName;
      if(toIE.DisplayProperties!=null) toIE.DisplayProperties.DisplayName = toIE.PreLabel.DisplayName;
    }
    else if(fromIE.Label!= null){
      if(toIE.Label==null) toIE.Label = new IELabel();
      toIE.Label.DisplayName = fromIE.Label.DisplayName;
      if(toIE.DisplayProperties!=null)toIE.DisplayProperties.DisplayName = toIE.Label.DisplayName;

    } else if(fromIE.Name!= null){
      toIE.Name = fromIE.Name;
      if(toIE.DisplayProperties!=null) toIE.DisplayProperties.DisplayName = toIE.Name;
    }
  }

  findIEFromGroups(cie: InterfaceElement, groups: InterfaceElement[], wizardIE: InterfaceElement, isDynaEdit: boolean){
    let ie: InterfaceElement;
    
    for(let gp of groups){
      let gpIndex = gp.InterfaceElements.map(function(e){return e.InterfaceElementID}).indexOf(cie.InterfaceElementID);
      if(gpIndex>-1){
        ie = gp.InterfaceElements[gpIndex]; 
        if(!isDynaEdit){
          const filteredInterfaceElements = gp.InterfaceElements.filter((item) => item.InterfaceElementID !== gp.InterfaceElements[gpIndex].InterfaceElementID);
          gp.InterfaceElements = filteredInterfaceElements;
        }
        break;
      }
    }

    if(ie == null && isDynaEdit == true){
      for(let wie of wizardIE.InterfaceElements){
        if(wie.InterfaceElementID == cie.InterfaceElementID && wie.TypeDID != InterfaceElementTypes.Wizard){
          ie = wie;
        }
      }
      if(ie==null){
        for(let g of groups){
          if(g.InterfaceElementID == cie.InterfaceElementID){
            ie = g;
          }
        }
      }
    }
    return ie;
  }

  setDisplayNamesFromDynaFormEditor(dynaItem, ie: InterfaceElement, cie: InterfaceElement){
    if(ie.DisplayProperties.DisplaySrcKey == "PreLabel"){
      cie.PreLabel = new IELabel();
      cie.PreLabel.DisplayName = dynaItem.PreLabel.DisplayName;
    }
    else if(ie.DisplayProperties.DisplaySrcKey == "Label"){
      cie.Label = new IELabel();
      cie.Label.DisplayName = dynaItem.Label.DisplayName;
    }
    else if(ie.DisplayProperties.DisplaySrcKey == "Name"){
      cie.Name = dynaItem.Name;
    }
    return cie;
  }


 
}
